export const DELIVERY_ZONE_NAME_MIN_LENGTH = 2;

export const DELIVERY_ZONE_NAME_MAX_LENGTH = 60;

export const DELIVERY_ZONE_NAME_ERROR = `Entre ${DELIVERY_ZONE_NAME_MIN_LENGTH} et ${DELIVERY_ZONE_NAME_MAX_LENGTH} caractères`;

export const isDeliveryZoneNameValid = (name: string): boolean => {
  const trimmedLength = name.trim().length;
  return trimmedLength >= DELIVERY_ZONE_NAME_MIN_LENGTH && trimmedLength <= DELIVERY_ZONE_NAME_MAX_LENGTH;
};
